import {
	AfterViewInit,
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	Output,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import _cloneDeep from 'lodash/cloneDeep';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { FormioCustomComponent, FormioLoader } from 'dp-formio';

@Component({
	selector: 'card-wrapper',
	templateUrl: './card-wrapper.component.html',
	// styleUrls: ['./card-wrapper.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [FormioLoader],
})
export class CardWrapperComponent
	implements FormioCustomComponent<any>, AfterViewInit, OnDestroy
{
	dir: 'rtl' | 'ltr';

	@ViewChild('form') form: any;
	@Input() value: any = {};
	@Output() valueChange = new EventEmitter<any>();
	@Output() formSubmitted = new EventEmitter<any>();
	@Input() viewOnly: boolean;
	@Input() data: any;
	@Input() customOptions: any;
	@Input() formioComponent: any;
	disabled: boolean;

	subscriptions$: Subscription[] = [];
	set sub(s: Subscription) {
		this.subscriptions$.push(s);
	}

	get hasTitle() {
		return !!this.customOptions?.title?.toString()?.trim().length;
	}

	get hasDescription() {
		return !!this.customOptions?.description?.toString()?.trim().length;
	}

	constructor(private translateService: TranslateService) {
		this.changeDirection(this.translateService.currentLang);
	}

	ngAfterViewInit(): void {
		this.sub = this.translateService.onLangChange.subscribe((data) => {
			this.changeDirection(data.lang);
		});
	}

	private changeDirection(lang) {
		this.dir = null;
		setTimeout(() => {
			this.dir = lang == 'ar' ? 'rtl' : 'ltr';
		});
	}

	notifyValue(rate) {
		this.value = rate;
		this.valueChange.emit(this.value);
	}

	ngOnDestroy() {
		this.subscriptions$.forEach((o) => o.unsubscribe());
		this.subscriptions$ = [];
	}
	evaluateAction(event: string) {
		if (!event) return;
		eval(event);
	}
}
